var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 139,
    viewBox: "0 0 178 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 178,
    height: 139
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.903 0.435486H0.0967742V138.565H177.903V0.435486Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.663 123.505H12.3368C9.3065 123.505 6.84999 125.962 6.84999 128.992V129.252C6.84999 132.282 9.3065 134.739 12.3368 134.739H165.663C168.693 134.739 171.15 132.282 171.15 129.252V128.992C171.15 125.962 168.693 123.505 165.663 123.505Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5634 17.9848V35.6267H88.397L74.1394 53.8381L59.8816 35.6267H67.7152V17.9837L80.5634 17.9848Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.103 45.5968H93.2675V53.8381H147.103V45.5968Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.106 115.838H93.2675C84.5331 91.0316 93.2675 53.8381 93.2675 53.8381H147.103C147.103 53.8381 153.265 79.9384 149.48 102.226",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.832 115.838H93.2675V123.527H166.741C166.741 123.527 166.732 119.587 162.317 118.433C162.317 118.433 162.182 111.776 156.34 111.776C156.34 111.776 157.835 104.712 150.023 104.237C150.023 104.237 148.461 97.4898 142.416 97.852C135.898 98.2426 135.42 104.712 135.42 104.712C135.42 104.712 130.054 104.842 129.511 111.505C129.511 111.505 123.375 112.478 123.647 118.184C123.647 118.184 119.005 118.274 119.005 123.346",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.236 82.1226V101.118",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.511 91.9518L119.236 94.4753",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.96 91.9518L119.236 94.4753",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.944 91.4344C123.153 89.9314 124.716 81.6604 133.756 82.7195C133.881 82.7341 133.974 82.8444 133.965 82.9694C133.861 84.4736 132.841 93.0586 123.147 91.7002C123.018 91.6821 122.927 91.5633 122.944 91.4344Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.191 91.4344C114.982 89.9314 113.419 81.6604 104.379 82.7195C104.255 82.7341 104.162 82.8444 104.17 82.9694C104.274 84.4736 105.295 93.0586 114.988 91.7002C115.117 91.6821 115.209 91.5633 115.191 91.4344Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.463 82.4561C120.813 81.1479 127.936 73.5341 120.264 65.2737C120.159 65.16 119.98 65.1473 119.861 65.2474C118.434 66.4519 110.6 73.7527 119.049 82.4478C119.162 82.5634 119.348 82.5683 119.463 82.4561Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7021 119.924V116.13H69.294V122.323",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7021 86.7721V76.1175C27.7021 74.405 29.0905 73.0166 30.803 73.0166H66.193C67.9056 73.0166 69.294 74.405 69.294 76.1175V92.2087",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7021 113.799V86.1477",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5234 93.438H42.4726C41.0241 93.438 39.8496 92.2635 39.8496 90.8148C39.8496 89.3661 41.0241 88.1918 42.4726 88.1918H54.5234C55.972 88.1918 57.1465 89.3661 57.1465 90.8148C57.1465 92.2635 55.972 93.438 54.5234 93.438Z",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.315 73.0166L29.3467 73.3833L31.9138 60.7696C31.9138 60.0519 32.4958 59.4699 33.2136 59.4699H37.546C38.2639 59.4699 38.8458 60.0519 38.8458 60.7696L40.315 73.0166Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8134 78.9661V115.486C20.8134 116.915 21.972 118.074 23.4013 118.074H27.7021V123.505H69.294",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8134 79.0391C19.7367 79.0391 18.8638 78.1662 18.8638 77.0895V64.9425C18.8638 63.8658 19.7367 62.9929 20.8134 62.9929C21.8901 62.9929 22.763 63.8658 22.763 64.9425V77.0895C22.763 78.1662 21.8901 79.0391 20.8134 79.0391Z",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7421 63.0442H44.1898C46.594 63.0442 48.498 64.9932 48.498 67.3973V73.0166",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1405 89.2315L54.6227 60.747",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5904 117.947L75.6062 117.985C76.2302 119.503 77.7086 120.493 79.3491 120.493C81.5843 120.493 83.3963 118.681 83.3963 116.446V90.4174C83.3963 87.3227 80.8874 84.8138 77.7924 84.8138H69.294",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3636 100.72L71.6275 115.197C72.1618 116.667 73.7864 117.425 75.2559 116.89C76.7255 116.356 77.4836 114.732 76.9491 113.262L67.8529 88.2453L62.5313 90.1803L64.2677 94.9555L66.3636 100.72Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7132 60.9538L52.7172 56.6936L55.959 59.6723L52.7132 60.9538Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon03.60e4bc5b23c2a63a3370e1196b0c86de.svg";
export { ForwardRef as ReactComponent };